import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=auth
  const [org, setOrg] = useState(null);
  const [impersonation, setImpersonation] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrg(data.org);
      setImpersonation(data.impersonation || null);
    } catch {
      setUser(false);
      setOrg(null);
      setImpersonation(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: returning from Google OAuth -> let AuthCallback exchange the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    await api.post("/auth/login", { email, password });
    await loadMe();
  };
  const register = async (payload) => {
    await api.post("/auth/register", payload);
    await loadMe();
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false); setOrg(null); setImpersonation(null);
  };
  const stopImpersonation = async () => {
    await api.post("/admin/stop-impersonation");
    await loadMe();
  };

  return (
    <AuthContext.Provider value={{ user, org, setOrg, loadMe, login, register, logout, apiError, impersonation, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
